var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvalanche(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.0885,
    cy: 12.0961,
    rx: 10.6471,
    ry: 10.6542,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 12C24 18.6275 18.6275 24 12 24C5.37258 24 0 18.6275 0 12C0 5.37258 5.37258 0 12 0C18.6275 0 24 5.37258 24 12ZM8.59954 16.7754H6.27068C5.78132 16.7754 5.53959 16.7754 5.3922 16.6811C5.23301 16.5779 5.13573 16.4069 5.12394 16.2182C5.11508 16.0444 5.23596 15.832 5.47769 15.4075L11.2279 5.27193C11.4726 4.84153 11.5964 4.62633 11.7527 4.54674C11.9207 4.46125 12.1212 4.46125 12.2892 4.54674C12.4454 4.62633 12.5693 4.84153 12.8139 5.27193L13.9961 7.33548L14.0021 7.34601C14.2664 7.80775 14.4004 8.0419 14.4589 8.28765C14.5237 8.55592 14.5237 8.83892 14.4589 9.10719C14.3999 9.35481 14.2673 9.59065 13.999 10.0594L10.9785 15.3987L10.9707 15.4124C10.7047 15.8779 10.5699 16.1139 10.3831 16.2919C10.1796 16.4865 9.93496 16.6279 9.6667 16.7076C9.42201 16.7754 9.14787 16.7754 8.59954 16.7754ZM14.4807 16.7754H17.8177C18.31 16.7754 18.5577 16.7754 18.7051 16.6782C18.8643 16.575 18.9645 16.401 18.9734 16.2125C18.9819 16.0442 18.8637 15.8402 18.632 15.4403C18.624 15.4267 18.616 15.4129 18.6078 15.3988L16.9363 12.5393L16.9173 12.5071C16.6824 12.1099 16.5638 11.9093 16.4116 11.8318C16.2436 11.7463 16.046 11.7463 15.878 11.8318C15.7247 11.9114 15.6009 12.1207 15.3562 12.5422L13.6906 15.4017L13.6849 15.4116C13.4411 15.8324 13.3193 16.0428 13.3281 16.2153C13.3398 16.404 13.4371 16.5779 13.5963 16.6811C13.7408 16.7754 13.9884 16.7754 14.4807 16.7754Z",
    fill: "#E84142"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalanche);
export default __webpack_public_path__ + "static/media/avalanche.3552de276866361eb6ce1622ccb14661.svg";
export { ForwardRef as ReactComponent };